import React from "react";

const UploadInvoice = () => {
  return <div>UploadInvoice</div>;
};

export default UploadInvoice;
